module.exports = __webpack_public_path__ + "img/features-tabs-icon-02.c32ca5a1.svg";